export const AUTH =
  `${import.meta.env.VITE_API_BASE_URL}/v1/auth`

export const REFRESH_TOKEN =
  `${import.meta.env.VITE_API_BASE_URL}/v1/refresh-token`
